import RelativeDatePicker from 'components/form/RelativeDatePicker/styled';

export default RelativeDatePicker;
